import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HookScreen } from './screens/HookScreen';
import { AgeScreen } from './screens/AgeScreen';
import { FocusScreen } from './screens/FocusScreen';
import { CameraScreen } from './screens/CameraScreen';
import { SoftPaywallScreen } from './screens/SoftPaywallScreen';
import { AnalysisLoadingScreen } from './screens/AnalysisLoadingScreen';
import { AgeRevealScreen } from './screens/AgeRevealScreen';
import { BreakdownScreen } from './screens/BreakdownScreen';
import { HardPaywallScreen } from './screens/HardPaywallScreen';
import { PlanScreen } from './screens/PlanScreen';
import { PrivacyScreen } from './screens/legal/PrivacyScreen';
import { TermsScreen } from './screens/legal/TermsScreen';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HookScreen />} />
        <Route path="/age" element={<AgeScreen />} />
        <Route path="/focus" element={<FocusScreen />} />
        <Route path="/camera" element={<CameraScreen />} />
        <Route path="/soft-paywall" element={<SoftPaywallScreen />} />
        <Route path="/loading" element={<AnalysisLoadingScreen />} />
        <Route path="/reveal" element={<AgeRevealScreen />} />
        <Route path="/breakdown" element={<BreakdownScreen />} />
        <Route path="/paywall" element={<HardPaywallScreen />} />
        <Route path="/plan/:token" element={<PlanScreen />} />
        <Route path="/privacy" element={<PrivacyScreen />} />
        <Route path="/terms" element={<TermsScreen />} />
      </Routes>
    </BrowserRouter>
  );
}
